
import { WorldCountry } from '../types';
import { belgiumExpanded } from './belgiumExpansion';
import { switzerlandExpanded } from './switzerlandExpansion';

// Países europeos adicionales expandidos
export const finalEuropeCountries4: WorldCountry[] = [
  belgiumExpanded,
  switzerlandExpanded,
  
  // Lituania expandida
  {
    code: 'LT',
    name: 'Lithuania',
    slug: 'lithuania',
    population: 2795000,
    topCities: [
      { name: 'Vilnius', slug: 'vilnius', population: 588412 },
      { name: 'Kaunas', slug: 'kaunas', population: 383764 },
      { name: 'Klaipėda', slug: 'klaipeda', population: 192307 },
      { name: 'Šiauliai', slug: 'siauliai', population: 126976 },
      { name: 'Panevėžys', slug: 'panevezys', population: 114718 },
      { name: 'Alytus', slug: 'alytus', population: 66497 },
      { name: 'Marijampolė', slug: 'marijampole', population: 47613 },
      { name: 'Mažeikiai', slug: 'mazeikiai', population: 44317 },
      { name: 'Jonava', slug: 'jonava', population: 35400 },
      { name: 'Utena', slug: 'utena', population: 32165 },
      
      // Expanded to 100 cities
      { name: 'Kėdainiai', slug: 'kedainiai', population: 30000 },
      { name: 'Telšiai', slug: 'telsiai', population: 28000 },
      { name: 'Visaginas', slug: 'visaginas', population: 26500 },
      { name: 'Tauragė', slug: 'taurage', population: 28000 },
      { name: 'Ukmergė', slug: 'ukmerge', population: 25000 },
      { name: 'Plungė', slug: 'plunge', population: 22000 },
      { name: 'Kretinga', slug: 'kretinga', population: 21000 },
      { name: 'Šilutė', slug: 'silute', population: 20000 },
      { name: 'Radvilišis', slug: 'radvilisius', population: 18000 },
      { name: 'Gargždai', slug: 'gargzdai', population: 17000 },
      { name: 'Druskininkai', slug: 'druskininkai', population: 16000 },
      { name: 'Rokiškis', slug: 'rokiskis', population: 15500 },
      { name: 'Biržai', slug: 'birzai', population: 15000 },
      { name: 'Elektėnai', slug: 'elektrenai', population: 14500 },
      { name: 'Garliava', slug: 'garliava', population: 14000 },
      { name: 'Kuršėnai', slug: 'kursenai', population: 13500 },
      { name: 'Vilkaviškis', slug: 'vilkaviskis', population: 13000 },
      { name: 'Širvintos', slug: 'sirvintos', population: 12500 },
      { name: 'Anykščiai', slug: 'anyksciai', population: 12000 },
      { name: 'Lentvaris', slug: 'lentvaris', population: 11500 },
      { name: 'Grigiškės', slug: 'grigiskes', population: 11000 },
      { name: 'Joniškis', slug: 'joniskis', population: 10500 },
      { name: 'Rietavas', slug: 'rietavas', population: 10000 },
      { name: 'Kalvarija', slug: 'kalvarija', population: 9500 },
      { name: 'Palanga', slug: 'palanga', population: 9000 },
      { name: 'Neringa', slug: 'neringa', population: 8500 },
      { name: 'Prienai', slug: 'prienai', population: 8000 },
      { name: 'Jūrmala', slug: 'jurmala', population: 7500 },
      { name: 'Kelmė', slug: 'kelme', population: 7000 },
      { name: 'Varėna', slug: 'varena', population: 6500 },
      { name: 'Kaišiadorys', slug: 'kaisiadorys', population: 6000 },
      { name: 'Pasvalys', slug: 'pasvalys', population: 5500 },
      { name: 'Naujoji Akmenė', slug: 'naujoji-akmene', population: 5000 },
      { name: 'Ignalina', slug: 'ignalina', population: 4500 },
      { name: 'Zarasai', slug: 'zarasai', population: 4000 },
      { name: 'Molėtai', slug: 'moletai', population: 3500 },
      { name: 'Švenčionys', slug: 'svencionys', population: 3000 },
      { name: 'Trakai', slug: 'trakai', population: 2800 },
      { name: 'Salantai', slug: 'salantai', population: 2600 },
      { name: 'Šakiai', slug: 'sakiai', population: 2400 },
      { name: 'Kazlų Rūda', slug: 'kazlu-ruda', population: 2200 },
      { name: 'Jurbarkas', slug: 'jurbarkas', population: 2000 },
      { name: 'Raseiniai', slug: 'raseiniai', population: 1900 },
      { name: 'Pakruojis', slug: 'pakruojis', population: 1800 },
      { name: 'Kupiškis', slug: 'kupiskis', population: 1700 },
      { name: 'Šilalė', slug: 'silale', population: 1600 },
      { name: 'Skuodas', slug: 'skuodas', population: 1500 },
      { name: 'Akmenė', slug: 'akmene', population: 1400 },
      { name: 'Šiluva', slug: 'siluva', population: 1300 },
      { name: 'Radviliškis', slug: 'radviliskis', population: 1200 },
      { name: 'Kybartai', slug: 'kybartai', population: 1100 },
      { name: 'Vievis', slug: 'vievis', population: 1000 },
      { name: 'Eišiškės', slug: 'eisikes', population: 950 },
      { name: 'Šalčininkai', slug: 'salcininkai', population: 900 },
      { name: 'Pabradė', slug: 'pabrade', population: 850 },
      { name: 'Širvintos', slug: 'sirvintos-city', population: 800 },
      { name: 'Švenčionėliai', slug: 'svencioneliai', population: 750 },
      { name: 'Dūkštas', slug: 'dukstas', population: 700 },
      { name: 'Turmantas', slug: 'turmantas', population: 650 },
      { name: 'Linkuva', slug: 'linkuva', population: 600 },
      { name: 'Gruzdžiai', slug: 'grudziai', population: 580 },
      { name: 'Šeduva', slug: 'seduva', population: 560 },
      { name: 'Seda', slug: 'seda', population: 540 },
      { name: 'Vabalninkas', slug: 'vabalninkas', population: 520 },
      { name: 'Troškūnai', slug: 'troskunai', population: 500 },
      { name: 'Obeliai', slug: 'obeliai', population: 480 },
      { name: 'Dusetos', slug: 'dusetos', population: 460 },
      { name: 'Salakas', slug: 'salakas', population: 440 },
      { name: 'Tauragnai', slug: 'tauragnai', population: 420 },
      { name: 'Daugai', slug: 'daugai', population: 400 },
      { name: 'Veisiejai', slug: 'veisiejai', population: 380 },
      { name: 'Lazdijai', slug: 'lazdijai', population: 360 },
      { name: 'Seirijai', slug: 'seirijai', population: 340 },
      { name: 'Simnas', slug: 'simnas', population: 320 },
      { name: 'Gelgaudiškis', slug: 'gelgaudiskis', population: 300 },
      { name: 'Kudirkos Naumiestis', slug: 'kudirkos-naumiestis', population: 280 },
      { name: 'Šakiai', slug: 'sakiai-district', population: 260 },
      { name: 'Griškabūdis', slug: 'griskabudis', population: 240 },
      { name: 'Sintautai', slug: 'sintautai', population: 220 },
      { name: 'Lekėčiai', slug: 'lekeciai', population: 200 },
      { name: 'Pilviškiai', slug: 'pilviskiai', population: 190 },
      { name: 'Klaipėdos', slug: 'klaipedos', population: 180 },
      { name: 'Priekule', slug: 'priekule', population: 170 },
      { name: 'Vainutas', slug: 'vainutas', population: 160 },
      { name: 'Alsėdžiai', slug: 'alsedziai', population: 150 },
      { name: 'Endriejavas', slug: 'endriejavas', population: 140 },
      { name: 'Ylakiai', slug: 'ylakiai', population: 130 },
      { name: 'Viekšniai', slug: 'vieksniai', population: 120 },
      { name: 'Luokė', slug: 'luoke', population: 110 },
      { name: 'Žagarė', slug: 'zagare', population: 100 },
      { name: 'Joniškėlis', slug: 'joniskelis', population: 95 },
      { name: 'Šiaulėnai', slug: 'siaulenai', population: 90 },
      { name: 'Kurtuvėnai', slug: 'kurtuvenai', population: 85 },
      { name: 'Papilė', slug: 'papile', population: 80 },
      { name: 'Linkuva', slug: 'linkuva-district', population: 75 },
      { name: 'Šaukėnai', slug: 'saukenai', population: 70 },
      { name: 'Baisogala', slug: 'baisogala', population: 65 },
      { name: 'Šėta', slug: 'seta', population: 60 },
      { name: 'Dotnuva', slug: 'dotnuva', population: 58 },
      { name: 'Akademija', slug: 'akademija', population: 56 },
      { name: 'Surviliškis', slug: 'surviliskis', population: 54 },
      { name: 'Pagėgiai', slug: 'pagegiai', population: 52 },
      { name: 'Šilalė', slug: 'silale-district', population: 50 }
    ]
  }
];
